<template>
  <div
    v-if="data"
    class="validator-item border-bottom-1px"
  >
    <label :data-require="data.isneeded ? true : false">{{ data.fieldkey === 'from_info' ? (data.fromname) || $t('message["1370"]') : data.fieldname }}</label>
    <div class="fieldValue">
      <component
        :is="itemComponent"
        ref="formItem"
        :data="data"
        :placeholder="placeholder"
        @delete="handleDelete(data.fieldkey)"
        @change="handleChange"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import MyInput from '@/components/mobile/formItem/Input'
import InputList from '@/components/mobile/formItem/InputList'
import DateTime from '@/components/mobile/formItem/DateTime'
import StarRadio from '@/components/mobile/formItem/StarRadio'
import SelectTree from '@/components/mobile/formItem/SelectTree'
import MyTag from '@/components/mobile/formItem/Tag'
import MyEditor from '@/components/mobile/formItem/Editor1'
import MyTextarea from '@/components/mobile/formItem/Textarea'
import MyCascader from '@/components/mobile/formItem/Cascader2'
import MyFile from '@/components/mobile/formItem/File1'
import MyArea from '@/components/mobile/formItem/Area2'
import MySelect from '@/components/mobile/formItem/Select'
import MyCheckbox from '@/components/mobile/formItem/CheckBox'
import NotCanEdit from '@/components/mobile/formItem/NotCanEdit'
import IsChangedItem from '@/components/mobile/formItem/IsChanged'
import IsSensitive from '@/components/mobile/formItem/Sensitive'
import { debounce } from '@/lib/utils'

export default {
  components: {
  },
  props: {
    'data': {
      type: Object,
      default: () => ({})
    },
    'modulesData': {
      type: Object,
      default: () => ({})
    },
    'currentFrom': {
      type: [String, Number],
      default: () => ''
    }
  },
  data () {
    return {
      joinTeamSascaderShow: true,
      itemComponent: null
    }
  },
  computed: {
    ...mapState('inquery/detailData', ['repeatSaveItems', 'isBeiAn']),

    inquiryId () {
      return this.$route.params.inquiryId
    },
    placeholder () {
      if (!this.data) return

      const { fieldname = '', fieldtype = '', fieldconfig = {} } = this.data || {}
      const { placeholder = '' } = fieldconfig
      let spaceStr = this.$isEnglish ? ' ' : ''

      if (fieldtype === 'text' || fieldtype === 'ip' || fieldtype === 'number' || fieldtype === 'phone' || fieldtype === 'email' || fieldtype === 'editor' || fieldtype === 'tag') {
        return placeholder || this.$t('message["751"]') + spaceStr + fieldname
      } else {
        return placeholder || this.$t('message["855"]') + spaceStr + fieldname
      }
    }
  },

  async created () {
    this.setItem()
    const { fieldkey, fieldvalue } = this.data || {}

    // 跟进状态
    if (fieldkey === 'info_status') {
      this.toggleVisibleStatusModule(fieldvalue)
    }
    // 信息类型
    if (fieldkey === 'info_type') {
      this.toggleVisibleTypeModule(fieldvalue)
    }
  },

  methods: {
    ...mapActions('inquery/relateData', ['fetchRelateTeamInfo']),
    ...mapMutations('inquery/detailData', [
      'UPDATE_IS_DEAL'
    ]),
    ...mapMutations('inquery/relateData', [
      'UPDATE_IS_DISCARD',
      'UPDATE_IS_INVALID'
    ]),

    setOption (obj = {}, optionsData = []) {
      obj.options = []
      for (let i in optionsData) {
        const item = optionsData[i]
        let one = item
        if (obj.fieldtype === 'select') {
          one.text = item.name
          one.value = item.id
        } else if (obj.fieldtype === 'radio' || obj.fieldtype === 'checkbox') {
          // radio 的单独处理了，不用这里的设置
          one.label = item.name
          one.value = item.id
        }
        obj.options.push(one)
      }
    },
    setItem () {
      if (!this.data) return
      const { fieldkey, fieldtype, options, child, fieldconfig = {}, issensitive, ischanged, isedit, isneeded } = this.data || {}
      if (!fieldkey) return
      let itemComponent = null

      this.data.rules = this.data.rules || {}
      this.data.messages = this.data.messages || {}

      this.data.rules = {
        required: isneeded === 1
      }
      this.data.messages = { required: this.placeholder }

      switch (fieldtype) {
        case 'text':
        case 'number':
        case 'ip':
          itemComponent = MyInput
          this.data.fieldvalue = this.data.fieldvalue || ''
          break
        case 'email':
        case 'phone':
          itemComponent = InputList
          this.data.rules.type = 'array'

          this.data.fieldvalue = this.data.fieldvalue || []
          break
        case 'radio':
        case 'radioinfo_payfor':
        case 'radioinfo_level':
        case 'radioinfo_type':
        case 'radioinfo_followup':
          if (fieldconfig.type && parseInt(fieldconfig.type) === 2) {
            itemComponent = StarRadio
          } else {
            itemComponent = MySelect
          }

          this.data.fieldvalue = this.data.fieldvalue || ''
          this.setOption(this.data, options)
          break
        case 'select':
          itemComponent = MySelect
          this.data.fieldvalue = this.data.fieldvalue || ''
          this.setOption(this.data, options || child)
          break
        case 'checkbox':
          itemComponent = MyCheckbox
          this.data.fieldvalue = this.data.fieldvalue || []
          this.data.rules.type = 'array'
          this.setOption(this.data, options)
          break
        case 'editor':
          let ua = navigator.userAgent
          let isDingDing = (/DingTalk/.test(ua) && window.innerWidth < 500)

          itemComponent = MyTextarea
          if (isDingDing) {
            this.data.fieldvalue = this.data.fieldvalue || ''
          } else {
            itemComponent = MyEditor
          }
          break
        case 'file':
          itemComponent = MyFile
          this.data.rules.type = 'array'
          this.data.fieldvalue = this.data.fieldvalue || []
          break
        case 'select_tree':
          itemComponent = SelectTree
          this.data.children = options
          this.data.fieldvalue = this.data.fieldvalue || {}
          break
        case 'datetime':
          itemComponent = DateTime
          this.data.fieldvalue = this.data.fieldvalue || ''
          break
        case 'tag':
          itemComponent = MyTag
          this.data.rules.type = 'array'
          this.data.fieldvalue = this.data.fieldvalue || []
          break
        case 'area':
          itemComponent = MyArea
          this.data.fieldvalue = this.data.fieldvalue || {}
          break
        case 'cascader':
          itemComponent = MyCascader
          this.data.rules.type = 'array'
          this.data.fieldvalue = this.data.fieldvalue || []
          break
        case 'select_reception':
          itemComponent = MyCascader
          this.data.rules.type = 'array'
          if (isedit) {
            this.data.fieldvalue = this.data.fieldvalue || []
          }
          // 设置不必须选到父级
          this.$set(this.data, 'isMustLast', false)
          this.data.isMustLast = false
          break
        case 'string':
          itemComponent = NotCanEdit
          this.data.fieldvalue = this.data.fieldvalue || ''
          break
      }

      this.itemComponent = itemComponent

      if (issensitive && this.inquiryId) { // 敏感字段
        this.itemComponent = IsSensitive
        return
      }
      if (ischanged && this.inquiryId) { // 配置里删除
        this.itemComponent = IsChangedItem
        return
      }
      if (!isedit && this.inquiryId && fieldtype !== 'radioinfo_type') { // 不可编辑
        this.itemComponent = NotCanEdit
      }
    },
    validate (cb) {
      this.$refs.formItem && this.$refs.formItem.validate && this.$refs.formItem.validate(cb)
    },

    /**
     * val 返回每个组件选中的value值
     */
    handleChange (val) {
      if (!this.data) return
      const { fieldtype = '', fieldkey } = this.data || {}

      this.data.fieldvalue = val

      if (fieldtype === 'text' || fieldtype === 'number' || fieldtype === 'phone' || fieldtype === 'email' || fieldtype === 'select') {
        if (this.$route.name === 'InqueryCreate' || this.$route.name === 'InqueryDetail') {
          this.relateTeamInfo(this)
        }
      }
      // 跟进状态
      if (fieldkey === 'info_status') {
        this.toggleVisibleStatusModule(val)
      }
      // 信息类型
      if (fieldkey === 'info_type') {
        this.toggleVisibleTypeModule(val)
      }

      this.$emit('change', this.data)
    },

    toggleVisibleStatusModule (val) {
      if (val === '') return
      const { options = [] } = this.data || {}
      const filters = options.find(item => item.id === val)
      const name = filters && filters.name
      // 是否选择成交
      this.UPDATE_IS_DEAL(name === this.$t('message["109"]'))
      // 是否选择丢单
      this.UPDATE_IS_DISCARD(name === this.$t('message["1690"]'))
    },
    toggleVisibleTypeModule (val) {
      if (val === '') return
      const { options = [] } = this.data || {}
      const filters = options.find(item => item.id === val)
      const name = filters && filters.name

      // 是否选择无效
      this.UPDATE_IS_INVALID(name === this.$t('message["1766"]'))
    },

    /* 防抖：防止请求次数过多 */
    relateTeamInfo: debounce(async (_this) => { // 关联人员
      const { modulesData = {}, currentFrom = '' } = _this
      const { fieldkey = '', childObj = {} } = modulesData

      if (fieldkey === 'from_info' && childObj[currentFrom]) {
        const { fieldkey = '', child: childData = {} } = childObj[currentFrom]
        let params = {}
        params.fieldkey = fieldkey
        params.fromkv = {}

        for (let item of childData) {
          params.fromkv[item.fieldkey] = item.fieldvalue || ''
        }
        try {
          let chain = await _this.fetchRelateTeamInfo()
          chain
            .params(params)
            .fetch()
        } catch (error) {
          console.log(error)
        }
      }
    }, 1000),

    handleDelete (fieldkey) {
      this.$emit('delete', this.modulesData, fieldkey)
    },
    validatingHandler () {
      console.log('validating')
    },
    validatedHandler () {
      console.log('validated')
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
